import Gender from "./Gender.js";
import Category from "./Category.js";
import Boat from "./Boat.js";

export default class Distance {
    constructor(id, distance, gender, category, boat) {
        this.id = id;
        this.distance = distance;
        this.Gender = gender instanceof Gender ? gender : new Gender(gender?.id, gender?.gender);
        this.Categories = category instanceof Category ? category : new Category(category?.id, category?.category);
        this.Boat = boat instanceof Boat ? boat : new Boat(boat?.id, boat?.boat, boat?.amount_of_people);
    }
}
